import { render } from "./AuthClient.vue?vue&type=template&id=407f7c9e"
import script from "./AuthClient.vue?vue&type=script&lang=js"
export * from "./AuthClient.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__